<template>
  <div class="fechamentoMes">
    <div class="descTable">
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <h2 style="color:white; box-shadow: 1px 1px 8px black;">
            <svg
              style="width:24px;height:24px;margin-left: 87px;margin-bottom: -4px;"
              viewBox="0 0 24 24"
            >
              <path
                fill="#fff"
                d="M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M16.53,11.06L15.47,10L10.59,14.88L8.47,12.76L7.41,13.82L10.59,17L16.53,11.06Z"
              ></path>
            </svg>
            Fechamento de Mês
            <transition name="slide-fade">
              <v-icon v-if="!empresa._id" class="mr-2 ml-2 loading fechamento_loop">loop</v-icon>
            </transition>
          </h2>
        </v-flex>
      </v-layout>
    </div>

    <v-card v-if="empresa._id" class="card_fechamentoMes" flat>
      <small class="desc_ribbon">Fechamento de mês para:</small>
      <!-- <article style="max-height: 132px;overflow-y: scroll;">
        <div style="position: relative" v-for="(item, i) in emprSelecionadas" :key="i">
          <Ribbon class="mb-4" :mainText="item.razao" :cnpjCpf="item.cnpj" :icon="'domain'"></Ribbon>
            <v-tooltip bottom style="position: absolute;right: 0;top: -4px;">
              <v-btn
                slot="activator"
                color="green darken-2"
                icon
                flat
                text-color="white"
                dark
                @click.native="rmvItem(item)"
              >
                <v-icon class="material-icons" dark color="red">close</v-icon>
              </v-btn>
              <span>Remover empresa({{maskCnpj(item.cnpj)}}) do fechamento mensal</span>
            </v-tooltip>
        </div>
      </article>-->

      <v-combobox
        class="fechamento_listaEmpresas"
        v-model="emprSelecionadas"
        :items="conta.list_empresas"
        chips
        color="teal"
        return-object
        label="Empresas: "
        item-text="razao"
        :multiple="true"
        item-value="_id"
        @change="handleEmpresas"
        :menu-props="{contentClass:'email_combo'}"
      >
        <template slot="selection" slot-scope="data">
          <v-chip
            :selected="data.selected"
            :disabled="data.disabled"
            close
            class="v-chip--select-multi"
            @input="remove(data.item)"
          >
            <v-avatar
              class="teal white--text"
            >{{ data.item != undefined && data.item.razao ? data.item.razao.slice(0, 1).toUpperCase() : ''}}</v-avatar>
            <!-- {{ data.item != undefined ? data.item.razao : ''}} -->
            {{data.item.razao}}
          </v-chip>
        </template>
      </v-combobox>

      <Stepper :empresa="emprSelecionadas" :conta="conta" :alert="alert"></Stepper>
    </v-card>
  </div>
</template>
<script>
import ContaService from "@/domain/conta/ContaService.js";
import Ribbon from "@/components/shared/ribbon/Ribbon.vue";
import Stepper from "@/components/stepperFechamentoMes/StepperFechamentoMes";
export default {
  props: ["conta", "empresa", "alert"],
  components: {
    Ribbon: Ribbon,
    Stepper: Stepper
  },
  data() {
    return {
      emprSelecionadas: [],
      modalEmpresas: false
    };
  },
  created() {},
  mounted: function() {
    this.$nextTick(function() {});
  },
  methods: {
    handleEmpresas() {
      if(this.emprSelecionadas.length > 0) {
        this.emprSelecionadas.map((item, index) => {
          if(!item.razao) {
            this.emprSelecionadas.splice(index, 1);
          }
        })
      }
    },
    remove(item) {
      const index = this.emprSelecionadas.indexOf(item);
      if (index >= 0) this.emprSelecionadas.splice(index, 1);
    },
    rmvItem(item) {
      if (item) {
        let index = this.emprSelecionadas.indexOf(item);
        this.emprSelecionadas.splice(index, 1);
      }
    },
    maskCnpj: function(cnpj) {
      return cnpj
        ? cnpj.length > 11
          ? cnpj.replace(
              /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
              "$1.$2.$3/$4-$5"
            )
          : cnpj.replace(/^(\d{3})(\d{3})(\d{3})(\d)/, "$1.$2.$3-$4")
        : "";
    },
    begin: function() {}
  }
};
</script>
<style scoped>
.fechamentoMes h2 {
  font-weight: normal;
  background-color: teal;
}
.fechamentoMes .fechamento_loop {
  font-size: 22px;
  font-weight: bold;
  color: cyan;
}
.fechamentoMes .desc_ribbon {
  margin: 0px auto;
  width: 100%;
  text-align: center;
  display: inline-block;
  color: grey;
  font-weight: bold;
}
.card_fechamentoMes {
  margin-top: 50px !important;
  width: 80%;
  margin: 0 auto;
  padding: 40px;
  background-color: #efefef;
}

.slide-fade-enter-active {
  opacity: 1;
  transition: all 0.2s cubic-bezier(0, 1.11, 0.83, 0.67);
}
.slide-fade-leave-active {
  opacity: 0;
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active em versões anteriores a 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.loading {
  animation-name: loading;
  animation: loading 2s infinite;
}
@-webkit-keyframes loading {
  from {
    transform: rotate(0) scaleX(-1);
  }
  to {
    transform: rotate(180deg) scaleX(-1);
  }
}

@keyframes loading {
  from {
    transform: rotate(0) scaleX(-1);
  }

  to {
    transform: rotate(180deg) scaleX(-1);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/loggedArea/fechamentoMes/FechamentoMes.vue